export class UTMBuilder {
  static build(
    params: string | URLSearchParams | Record<string, string> | [string, string][] | string[][] | undefined
  ): string {
    const utms = new URLSearchParams(params);
    return '?'.concat(utms.toString()).toLowerCase();
  }
}
